import * as R from "ramda"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DefaultValue = any
type Path = string | number | (string | number)[]
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Input = any

const getValue = (path: Path, input: Input) => {
  const pathArr: (string | number)[] = Array.isArray(path) ? path : String(path).split(".")
  const pathLens = R.lensPath(pathArr)

  return R.view(pathLens, input)
}

export const getOr = R.curry((defaultValue: DefaultValue, path: Path, input: Input) => {
  const value = getValue(path, input)

  return value === undefined ? defaultValue : value
})

export const get = R.curry(getValue)
